import { render, staticRenderFns } from "./LabelLaudoSituacao.vue?vue&type=template&id=67d3b0da&scoped=true&lang=pug"
import script from "./LabelLaudoSituacao.vue?vue&type=script&lang=js"
export * from "./LabelLaudoSituacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d3b0da",
  null
  
)

export default component.exports